module.exports = __webpack_public_path__ + "static/Nubank-e2904721fcf5b274d475a6fc1068e75f.jpg";